import { TachographConnectivity, TachographStatus } from "../models/Tachograph";
import { DAY_MS } from "./tachographDates";

/** A tachograph that has not reported for this long counts as unreliable. */
const DEGRADED_SIGNAL_AGE_MS = 2 * DAY_MS;

/** Beyond this the tachograph counts as unreachable. */
export const OFFLINE_SIGNAL_AGE_MS = 14 * DAY_MS;

export function getStatusColor(status: TachographStatus | TachographConnectivity): string {
  if (status === "ok" || status === "online") return "success.main";
  if (status === "warning" || status === "degraded") return "warning.main";

  return "error.main";
}

/**
 * Due date is the reference date plus the interval; without a reference date nothing is known.
 * Within `warningDays` of the due date the readout counts as due soon.
 */
export function deriveStatusFromReferenceDate(
  referenceDate: Date | null,
  intervalDays: number,
  warningDays: number,
  now: Date,
): TachographStatus {
  if (!referenceDate) return "warning";

  const remainingMs = referenceDate.getTime() + intervalDays * DAY_MS - now.getTime();
  if (remainingMs < 0) return "overdue";
  if (remainingMs <= warningDays * DAY_MS) return "warning";

  return "ok";
}

export function deriveConnectivityStatus(lastSignalDate: Date | null, now: Date): TachographConnectivity {
  if (!lastSignalDate) return "offline";

  const ageMs = now.getTime() - lastSignalDate.getTime();
  if (ageMs <= DEGRADED_SIGNAL_AGE_MS) return "online";
  if (ageMs <= OFFLINE_SIGNAL_AGE_MS) return "degraded";

  return "offline";
}
